import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AboutSection() {
  return (
    <section className="border-b border-slate-200 bg-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 sm:py-20 lg:grid-cols-2 lg:gap-14 lg:px-8">
        <div className="flex flex-col justify-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-sky-700">About</span>
          <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-slate-900 sm:text-4xl">
            HVAC Equipment Made Simple
          </h2>
          <p className="mt-4 text-slate-600">
            CA HVAC Direct makes it easier to shop for HVAC equipment online. Browse products from established manufacturers, compare equipment options, and find what you need for your project.
          </p>
          <p className="mt-4 text-slate-600">
            From air conditioners and furnaces to coils, air handlers, and mini-splits, our catalog brings HVAC equipment options together in one convenient place.
          </p>
          <div className="mt-8">
            <Button asChild variant="outline" className="rounded-sm border-slate-300" data-testid="about-learn-more">
              <Link to="/about">
                More about us <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>

        <div className="overflow-hidden rounded-sm border border-slate-200">
          <img
            src="/logo.png"
            alt="HVAC equipment and industry imagery"
            className="h-full max-h-[460px] w-full object-contain p-8"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
